// extracted by mini-css-extract-plugin
export var errorsContainer = "_qs-1";
export var link = "_qs-0";